import { render } from "./myPoint.vue?vue&type=template&id=1033ad72"
import script from "./myPoint.vue?vue&type=script&lang=js"
export * from "./myPoint.vue?vue&type=script&lang=js"

import "./myPoint.vue?vue&type=style&index=0&id=1033ad72&lang=scss"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__